import React from 'react';
import PropTypes from 'prop-types';
import { bibFieldShape } from '@bibliocommons/bc-prop-types';
import cn from 'classnames';

import FieldLabel from '../FieldLabel';
import FieldValue from '../FieldValue';

import './Field.scss';

export default function Field({ field, compact, handleClick }) {
  // If the first field has a content label, the field label needs to be aligned differently
  const firstValueHasContentLabel = !!field.getIn(['fieldValues', 0, 'contentLabel']);

  function renderFieldValue(fieldValue, i) {
    return (
      <li className="bib-field-value" key={i}>
        <FieldValue value={fieldValue} compact={compact} handleClick={() => handleClick(fieldValue)} />
      </li>
    );
  }

  return (
    <div className="cp-bib-field">
      <FieldLabel className={cn({ 'with-content-label': firstValueHasContentLabel })} field={field} />
      <ul className="values-list">{field.get('fieldValues').map(renderFieldValue)}</ul>
    </div>
  );
}

Field.propTypes = {
  field: bibFieldShape.isRequired,
  compact: PropTypes.bool,
  handleClick: PropTypes.func
};
